import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Category } from '@/types/category'
import { ref, watch, withDefaults } from "vue"

interface Props {
  categories: Category[];
  filterText?: string;
  hideAll?: boolean;
  currentNodeKey?: number;
  expandNodeKey?: number[];
}
// const props = defineProps<Props>();
interface Emits {
  (e: 'listClick', value: Category): void
  (e: 'openClick', value: Category): void
  (e: 'closeClick', value: Category): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    categories: { type: Array, required: true },
    filterText: { type: String, required: false, default: '' },
    hideAll: { type: Boolean, required: false, default: false },
    currentNodeKey: { type: Number, required: false },
    expandNodeKey: { type: Array, required: false }
  },
  emits: ["listClick", "openClick", "closeClick"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'listClick', value: Category): void
  (e: 'openClick', value: Category): void
  (e: 'closeClick', value: Category): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { categories: Category[], filterText: string, hideAll: boolean, currentNodeKey?: number, expandNodeKey?: number[] }



let categoryTree: any = ref(null);
const categoryProps = {
  children: 'children',
  label: 'name',
}
watch(() => props.filterText, () => {
  if (categoryTree.value != null) {
    categoryTree.value.filter(props.filterText)
  }
})

const filterCategory = (value: string, data: Category) => {
  if (!value) return true
  return data.name.indexOf(value) !== -1
}
const handleNodeClick = (data: Category) => {
  emit("listClick", data)
};
const treeOpen = (data: Category) => {
  emit("openClick", data)
};
const treeClose = (data: Category) => {
  emit("closeClick", data)
};

return (_ctx: any,_cache: any) => {
  const _component_el_tree = _resolveComponent("el-tree")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tree, {
      ref: (_value, _refs) => {
        _refs['categoryTree'] = _value
        _isRef(categoryTree) ? categoryTree.value = _value : categoryTree = _value
      },
      data: __props.hideAll ? __props.categories.filter(category => category.id !== 0) : __props.categories,
      props: categoryProps,
      onNodeClick: handleNodeClick,
      "filter-node-method": filterCategory,
      "node-key": "id",
      "current-node-key": __props.currentNodeKey,
      "default-expanded-keys": __props.expandNodeKey,
      "expand-on-click-node": false,
      "highlight-current": "",
      onNodeExpand: treeOpen,
      onNodeCollapse: treeClose
    }, null, 8, ["data", "current-node-key", "default-expanded-keys"])
  ]))
}
}

})